export function aggregateCustomsFromDeclarations(
  declarations?: DeclarationsParamsOutput[],
): ApplicationCustomsTotals | null {
  if (!declarations?.length) {
    return null
  }

  return declarations.reduce<ApplicationCustomsTotals>((acc, declaration) => {
    const codes = declaration.codes ?? []
    const dutySum = codes.reduce((sum, code) => sum + (Number(code.duty) || 0), 0)
    const exciseSum = codes.reduce((sum, code) => sum + (Number(code.excise) || 0), 0)

    return {
      customsValue: acc.customsValue + (declaration.lowin_total || 0),
      customsPayments: acc.customsPayments + dutySum,
      vat: acc.vat + (declaration.vat_total || 0),
      excise: acc.excise + exciseSum,
      utilization: acc.utilization + (declaration.utilization_total || 0),
      environmental: acc.environmental + (declaration.environmental_total || 0),
      customsFee: acc.customsFee + (declaration.tax_total || 0),
      total: acc.total + (declaration.fees_total || 0),
    }
  }, {
    customsValue: 0,
    customsPayments: 0,
    vat: 0,
    excise: 0,
    utilization: 0,
    environmental: 0,
    customsFee: 0,
    total: 0,
  })
}

export function getSummaryProductPurchaseTotal({ product, invoiceProductsById, invoiceId }: ApplicationGetSummaryProductPurchaseTotalArgs
): number | undefined {
  const fromSummary = product.invc_total ?? product.price_total
  if (fromSummary != null) {
    const numeric = Number(fromSummary)
    if (!Number.isNaN(numeric)) {
      return numeric
    }
  }

  const invoiceProducts = invoiceId != null ? invoiceProductsById?.get(invoiceId) : undefined
  const match = invoiceProducts?.find((item) => item.code === product.code)
    ?? invoiceProducts?.find((item) => item.name === product.name)

  if (match?.price_total != null) {
    const numeric = Number(match.price_total)
    if (!Number.isNaN(numeric)) {
      return numeric
    }
  }

  return undefined
}

